import React from 'react';

import Tooltip from 'CommonComponents/Tooltip';

import CircleInfoIcon from 'Assets/icons/circle-info.svg';

/**
 * The (i) beside a column or card title. A button rather than a bare icon so
 * keyboard users can reach the definition too.
 */
export default function BudgetOverviewInfoTip({ label, text }) {
    return (
        <Tooltip tooltipType="text" tooltipContent={text} placement="top">
            <button type="button" aria-label={`${label}: ${text}`} className="tw-inline-flex tw-items-center tw-align-middle tw-text-current">
                <CircleInfoIcon className="tw-w-3.5 tw-h-3.5" />
            </button>
        </Tooltip>
    );
}
